import { useQuery } from "@apollo/client";
import { useParams } from "react-router";

import { GqlMapEditorFeatureSearchParams } from "~/__generated__";
import { useMapFilters } from "~/modules/project/hooks/useMapFilters";

import { MapEditorFeatureListRoute_QueryDocument } from "./queries.generated";

export function useMapEditorFeatureListRouteData({ pageSize, page }: { pageSize: number; page: number }) {
    const { layerId, visitId } = useParams();
    const { filters } = useMapFilters();

    const mapToQueryParams: GqlMapEditorFeatureSearchParams = {
        pageSize: pageSize,
        page: page,
        ecologicalFunctionTypeIds: filters.ecologicalFunctionTypeIds,
        typeIds: filters.observationTypeIds,
        researchTypeIds: filters.researchType?.map(x => x.researchTypeId),
        speciesIds: filters.researchType?.map(x => x.speciesId),
        status: filters.observationStatus !== undefined ? [filters.observationStatus] : undefined,
        layerIds: layerId !== undefined ? [layerId] : undefined,
        visitIds: visitId !== undefined ? [visitId] : filters.visitIds,
    };

    const { data, previousData, error } = useQuery(MapEditorFeatureListRoute_QueryDocument, {
        variables: { params: mapToQueryParams },
    });

    const result = data ?? previousData;

    return {
        features: result?.mapEditorFeatureGetAll.data,
        featuresQueryInfo: result?.mapEditorFeatureGetAll.queryInfo,
        error,
    };
}
